
import { Product } from "@/lib/types";
import { calculateDaysOfSupply, needsRestocking } from "@/lib/storage/stock/helpers";

export const getStatusColor = (daysRemaining: number, minStockAlert: number) => {
  if (daysRemaining <= minStockAlert / 2) return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300";
  if (daysRemaining <= minStockAlert) return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300";
  return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300";
};

export const getProgressColor = (daysRemaining: number, minStockAlert: number) => {
  if (daysRemaining <= minStockAlert / 2) return "bg-red-500";
  if (daysRemaining <= minStockAlert) return "bg-yellow-500";
  return "bg-teal-500";
};

export const getProgressValue = (daysRemaining: number, minStockAlert: number) => {
  return Math.min(100, Math.max(0, (daysRemaining / (minStockAlert * 2)) * 100));
};

export const formatDate = (date: Date) => {
  return new Date(date).toLocaleDateString();
};
